import React, { useState } from 'react';

const AdminLinkedInPreviewModal = ({ initialText, onPost, onCancel, isPosting }) => {
    const [postText, setPostText] = useState(initialText);

    const handlePost = () => {
        onPost(postText);
    };

    // We add the new 'nested-modal-overlay' class here
    return (
        <div className="admin-modal-overlay nested-modal-overlay" onClick={onCancel}>
            {/* We add stopPropagation here to prevent the modal from closing when clicking inside it */}
            <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>Preview LinkedIn Post</h2>
                <p>You can make final edits to the text below before publishing.</p>
                <div className="form-group">
                    <textarea 
                        value={postText}
                        onChange={(e) => setPostText(e.target.value)}
                        rows="15"
                        style={{ width: '100%', resize: 'vertical' }}
                    />
                </div>
                <div className="form-actions">
                    <button type="button" onClick={onCancel} className="btn-secondary" disabled={isPosting}>
                        Cancel
                    </button>
                    <button type="button" onClick={handlePost} className="btn-primary" disabled={isPosting}>
                        {isPosting ? 'Publishing...' : 'Post Now'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminLinkedInPreviewModal;